export class ScreeningExecutionResult {
    constructor() {
        this.companyId = null;
        this.feedbackAnswersList = [];
        this.jobDetailsRecruiterScreeningList = [];
        this.companyAndOverallComplete;
        this.fromButton;
        this.meetingScheduleId;
        this.externalMeetingId;
    }
}
//# sourceMappingURL=screeningExecutionResult.js.map